import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

export const SummaryColumn = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 3,
      key: "officeInfoBn",
      name: "ইউনিটের নাম",
      render: (officeInfoBn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {officeInfoBn}
        </Text>
      ),
    },
    {
      id: 4,
      key: "employeePost",
      name: "মঞ্জুরীকৃত পদ",
      render: (employeePost: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {employeePost}
        </Text>
      ),
    },
    {
      id: 5,
      key: "totalCurrentEmployee",
      name: "কর্মরত",
      render: (totalCurrentEmployee: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {totalCurrentEmployee}
        </Text>
      ),
    },
    {
      id: 6,
      key: "totalVacancy",
      name: "শূন্য",
      render: (totalVacancy: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {totalVacancy}
        </Text>
      ),
    },
  ];
};
